// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DeJWN","tooltip":"styles_tooltip__3Naha"};